﻿'use strict';

/**
 * [init Initilizes cookie consent]
 * @param  {[string]} scope [A css selector]
 * @return {[undefined]}    [Nothing to return]
 */
export

function init(scope) {
    if ($(scope).length) {
        function setHandlers() {
            $(scope).find('input').each(function(index, inp) {
                $(inp).on('blur', function() {
                    $(this).formatCurrency({
                        symbol: '',
                        decimalSymbol: ',',
                        digitGroupSymbol: '.'
                    });
                });
            });
        }

        setHandlers();
        $(scope).on('submit', function(e) {
            var form = $(this);
            var submitBtn = form.find('[type=submit]');

            submitBtn.addClass('btn--disabled');

            $.ajax({
                type: form.attr('method'),
                url: form.attr('action'),
                data: $(this).serialize(),
                success: function(data) {
                    form.html(data);
                    setHandlers();
                    submitBtn.removeClass('btn--disabled');
                }
            });
            e.preventDefault();
        });
       
    }
}